"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SHARED_Z_INDEX = exports.Types = void 0;
var Types = {
  Dark: 'OVERLAY/DARK',
  Light: 'OVERLAY/LIGHT',
  Loading: 'OVERLAY/LOADING',
  Transparent: 'OVERLAY/Transparent'
};
exports.Types = Types;
var SHARED_Z_INDEX = 0;
exports.SHARED_Z_INDEX = SHARED_Z_INDEX;